module.exports = __webpack_public_path__ + "static/media/mac-safari-icon.139274a4.png";